import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { parseURLParams } from "./Utils/helper";

const Header = ({ folderName }) => {
  const { startDate, endDate, term, folderId } = useParams();
  const [searchTerm, setSearchTerm] = useState(term || "");
  const [selectedStartDate, setStartDate] = useState(startDate || "");
  const [selectedEndDate, setEndDate] = useState(endDate || "");

  const location = useLocation();
  const path = location.pathname;
  const isGalleryPage = path.includes("/gallery");

  const handleSearchIconClick = () => {
    setFilterUrl(selectedStartDate, selectedEndDate, searchTerm);
  };

  const setFilterUrl = (startDate, endDate, searchTerm) => {
    console.log(startDate, endDate, searchTerm);
    if (startDate && endDate && searchTerm) {
      window.location.href = `/search/${searchTerm}/${startDate}/${endDate}`;
    } else if (searchTerm) {
      window.location.href = `/search/${searchTerm}`;
    } else if (startDate && endDate) {
      window.location.href = `/search/${startDate}/${endDate}`;
    }
  };

  const handleFilterButtonClick = () => {
    if (selectedStartDate && selectedEndDate) {
      setFilterUrl(selectedStartDate, selectedEndDate, searchTerm);
      // window.location.href = `/search/${selectedStartDate}/${selectedEndDate}`;
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearchIconClick();
    }
  };

  let from = "";
  try {
    var urlParams = parseURLParams(window.location.href);
    if (urlParams && urlParams["from"].length > 0) {
      from = urlParams["from"][0];
    }
    // console.log(from);
  } catch (error) {}

  return (
    <>
      <nav className="nav_bg">
        <div className="photonav_container photonav_container_mob">
          <div className="photnav_flex">
            <div className="photo_div">
              <h3 className="phot_head" style={{ color: "#2e3192" }}>
                {from == "desktop" ? (
                  <>
                    <a
                      style={{
                        cursor: "pointer",
                        color: "#2e3192",
                        fontFamily: "ek_muktaextralight",
                        // fontSize: "50px",
                      }}
                      onClick={() => {
                        window.parent.location.href =
                          "https://www.narendramodi.in/";
                      }}
                    >
                      Narendra{" "}
                      <b
                        style={{
                          fontFamily: "ek_muktamedium",
                          fontWeight: "normal",
                        }}
                      >
                        Modi
                      </b>
                    </a>
                    <a
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        window.parent.location.href =
                          "https://www.narendramodi.in/photo-gallery";
                      }}
                    >
                      {" "}
                      | Photo Gallery
                    </a>
                  </>
                ) : (
                  <>
                    {window.location.href.indexOf("appversion") != -1 ? (
                      <Link
                        to={"/" + window.location.search}
                        style={{
                          color: "#2e3192",
                          fontFamily: "ek_muktaextralight",
                          // fontSize: "50px",
                        }}
                      >
                        Narendra{" "}
                        <b
                          style={{
                            fontFamily: "ek_muktamedium",
                            fontWeight: "normal",
                          }}
                        >
                          Modi
                        </b>
                      </Link>
                    ) : (
                      <a
                        href={"https://www.narendramodi.in/"}
                        style={{
                          color: "#2e3192",
                          fontFamily: "ek_muktaextralight",
                          // fontSize: "50px",
                        }}
                      >
                        Narendra{" "}
                        <b
                          style={{
                            fontFamily: "ek_muktamedium",
                            fontWeight: "normal",
                          }}
                        >
                          Modi
                        </b>
                      </a>
                    )}
                    <Link
                      to={"/" + window.location.search}
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      | Photo Gallery
                    </Link>
                  </>
                )}
              </h3>
            </div>

            {(isGalleryPage || folderId) && (
              <h2 className="file_name_head">
                <img src="/assets/images/file.svg" alt="" />
                {folderName}
              </h2>
            )}

            {!isGalleryPage && !folderId && (
              <div className="search_input">
                <input
                  type="search"
                  placeholder="Search images"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
                <button onClick={handleSearchIconClick}>
                  <img src="/assets/images/search.svg" alt="Filter" />
                </button>
              </div>
            )}

            {!isGalleryPage && !folderId && (
              <div className="loc_list_div">
                <ul className="loc_list">
                  <li>
                    <h6>From</h6>
                    <div className="data_type">
                      <input
                        type="date"
                        placeholder="Start Date"
                        value={selectedStartDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                      <img src="/assets/images/calendar.svg" alt="" />
                    </div>
                  </li>
                  <li className="loc_pad">
                    <h6> to </h6>
                    <div className="data_type">
                      <input
                        type="date"
                        placeholder="End Date"
                        value={selectedEndDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                      <img src="/assets/images/calendar.svg" alt="" />
                    </div>
                  </li>
                  <li>
                    <button onClick={handleFilterButtonClick}>Filter</button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
